module.exports = __webpack_public_path__ + "img/icon_login.d615e923.svg";